import React from "react";
import { Icon } from "semantic-ui-react";

/**
 * The client's notice for each roleplay mode (UI UX_수정요청서_v1.0, requests 3-5).
 *
 * It used to sit in the 사전 연습하기 / 롤플레이 평가 응시 cards on /simulation. It moved to
 * the screen each card opens — the customer choice — so the cards fit a phone screen
 * without folding the rules away. A trainee still reads them before committing: a session
 * starts only after a customer is picked and 세션 시작 pressed.
 */
export const PRACTICE_NOTES = [
  "롤플레이를 시작하기 전 사전 연습을 할 수 있습니다.",
  "사전 연습은 횟수 관계없이 인당 최대 40분(누적) 동안 할 수 있습니다.",
];

// The quota rule mirrors api.utils.practice_budget.graded_attempts_used (an attempt is
// spent at MIN_CHATLOGS = 6 lines, evaluated or not) and canEvaluate in constants.js.
// `graded` is the allowances API's graded entry; exempt users (admins) have none.
export const gradedNotes = (graded) => [
  "예상 소요 시간은 약 15분~20분입니다. 카메라를 켜고 오디오가 녹음되니 비교적 조용한 공간에서 진행해 주세요.",
  "롤플레이는 25분 안에 종료되어야 합니다.",
  graded
    ? `본 평가는 ${graded.attempts_total === 1 ? "1회만" : `${graded.attempts_total}회까지`} 응시 가능하며, 결과가 평가 점수로 기록됩니다.`
    : "본 평가는 응시 횟수가 정해져 있으며, 결과가 평가 점수로 기록됩니다.",
  "대화가 발화 6개 이상(직원과 고객이 3번 이상 주고받기) 이어지면, 평가 받기를 누르지 않아도 1회로 차감됩니다. 그 전에 끝난 롤플레이는 차감되지 않습니다.",
  "평가는 발화 6개 이상인 롤플레이에서, 롤플레이마다 한 번 받을 수 있습니다.",
  "원하는 고객을 선택해 롤플레이를 시작합니다.",
];

/** The numbered list on its own — also used in full by /simulation's 평가 안내 confirm. */
export const NotesList = ({ notes, style }) => (
  <ol style={{ margin: 0, paddingLeft: "18px", fontSize: "13px", lineHeight: 1.6, color: "#424245", ...style }}>
    {notes.map((note, i) => (
      // Numbered: the client's copy is, and the order carries meaning.
      <li key={i} style={{ marginBottom: i === notes.length - 1 ? 0 : "4px" }}>
        {note}
      </li>
    ))}
  </ol>
);

/**
 * The notice as a card above the customer choice, folded to one line by default
 * ("유의사항 (N)") so the customers come first; the 평가 notes are also shown in full in
 * the confirm before this screen. `footnote` is the AI-image disclosure (client request 2),
 * moved here from the page header (2026-10-22).
 */
export const ModeNotes = ({ notes, footnote, style }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <div style={{ backgroundColor: "white", border: "1px solid rgba(0,0,0,0.05)", borderRadius: "16px", ...style }}>
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        style={{ width: "100%", display: "flex", alignItems: "center", gap: "6px", padding: "12px 16px", border: "none", background: "none", cursor: "pointer", fontFamily: "inherit", fontSize: "13px", fontWeight: 600, color: "#1d1d1f", textAlign: "left" }}
      >
        <Icon name="info circle" style={{ margin: 0, color: "#86868b" }} />
        <span style={{ flex: 1 }}>유의사항 ({notes.length})</span>
        <Icon name={open ? "chevron up" : "chevron down"} style={{ margin: 0, color: "#c7c7cc", fontSize: "12px" }} />
      </button>
      {open && (
        <div style={{ padding: "0 16px 14px" }}>
          <NotesList notes={notes} />
          {footnote && <p style={{ margin: "8px 0 0", fontSize: "12px", color: "#86868b" }}>{footnote}</p>}
        </div>
      )}
    </div>
  );
};
